import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../components/Generic/Seo";
import SignupForm from "../components/Registration/SignupForm";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import { isLoggedIn } from "../utility/UserUtils";

const SignupPage = () => {
  const navigate = useNavigate();

  const seoData = {
    title:
      "Sign Up - Wise CommuniSign Up to Join WiSE — Women in Semiconductor Ecosystem",
    description:
      "Join the WiSE community today. Sign up to connect, learn and grow in the Women in Semiconductor Ecosystem with mentorship, events and opportunities.",
    keywords:
      "WiSE signup, women in semiconductor signup, join WiSE, women in tech community signup",
    pathSlug: "signup",
  };

  useEffect(() => {
    if (isLoggedIn()) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <Seo data={seoData} />

      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <div className="auth-page">
        <SignupForm />
      </div>
    </>
  );
};

export default SignupPage;
